import { TRIP } from "@/data/itinerary";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#1D3A4C]/10 mt-24 bg-[#FAF8F4]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="font-display text-2xl text-[#1D3A4C]">
            {TRIP.title}
          </div>
          <p className="text-sm text-[#5C7180] mt-2 max-w-sm">{TRIP.subtitle}</p>
        </div>
        <div>
          <div className="font-accent text-xs text-[#8A9BA8] mb-3">Base</div>
          <a
            href={TRIP.hotel.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-hotel-link"
            className="text-[#1D3A4C] hover:text-[#D96C4A] transition-colors"
          >
            {TRIP.hotel.name} →
          </a>
          <div className="text-sm text-[#5C7180] mt-1">
            {TRIP.hotel.location}
          </div>
        </div>
        <div>
          <div className="font-accent text-xs text-[#8A9BA8] mb-3">Regola d'oro</div>
          <p className="text-sm text-[#1D3A4C]">
            Vento da nord → sud. Vento da sud → nord.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-8 text-xs text-[#8A9BA8]">
        Fatto con cura per la nostra vacanza — Agosto 2026.
      </div>
    </footer>
  );
}
